// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2XpFQ","footer":"ModalFilter_footer__3n6Qb"};